import { TransmissionType } from "../enum/transmissionType.enum";
import { SelectOption } from "../types/SelectOption";

export const transmissionTypes: SelectOption[] = [
  { label: "Automatic", id: TransmissionType.Automatic },
  { label: "Manual", id: TransmissionType.Manual },
  // { label: "Other", id: 3 },
];

export const transmissionTypesWithAny: SelectOption[] = [{ label: "Any", id: -1 }, ...transmissionTypes]